"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var AppIntegrations_module_css_1 = __importDefault(require("./AppIntegrations.module.css"));
var AppIntegrationTemplateMenu_1 = __importDefault(require("./AppIntegrationTemplateMenu"));
var AppIntegrationEditor_1 = __importDefault(require("./AppIntegrationEditor"));
var AppIntegrationEditorModal = function (props) {
    var _a, _b;
    var _c = (0, react_1.useState)(undefined), appIntegrationTemplateId = _c[0], setAppIntegrationTemplateId = _c[1];
    var _d = (0, react_1.useState)(""), modalTitle = _d[0], setModalTitle = _d[1];
    var _e = (0, react_1.useState)(false), saveError = _e[0], setSaveError = _e[1];
    var onSaveHandler = function (appIntegration) {
        if (!props.integration) {
            props.closeModal();
        }
        props.setIntegration(appIntegration);
        setAppIntegrationTemplateId(undefined);
    };
    var onCloseHandler = function () {
        setAppIntegrationTemplateId(null);
        setSaveError(false);
        props.closeModal();
    };
    return (react_1.default.createElement(q_play_components_1.Modal, { isShown: props.isShown, onClose: onCloseHandler, headerText: modalTitle, body: appIntegrationTemplateId || ((_a = props.integration) === null || _a === void 0 ? void 0 : _a.id)
            ? react_1.default.createElement(AppIntegrationEditor_1.default, { permissions: props.permissions, setTitle: setModalTitle, appIntegrationId: (_b = props.integration) === null || _b === void 0 ? void 0 : _b.id, appIntegrationTemplateId: appIntegrationTemplateId, closeModal: onCloseHandler, saveError: saveError, setSaveError: setSaveError, onSave: onSaveHandler })
            : react_1.default.createElement(AppIntegrationTemplateMenu_1.default, { setTitle: setModalTitle, setAppIntegrationTemplateId: setAppIntegrationTemplateId }), centered: true, dataCy: "IntegrationEditorModal", dialogClassName: AppIntegrations_module_css_1.default["integration-editor-modal"] }));
};
exports.default = AppIntegrationEditorModal;
